import { useContext, useEffect, useState } from "react";

import { FirebaseContext } from "./filrebase";

const useUser = () => {
  const firebase = useContext(FirebaseContext);
  const { currentUser } = firebase.auth();
  const [{ user, loading }, setState] = useState({
    user: currentUser,
    loading: true
  });
  const logout = () => {
    firebase.auth().signOut();
  };

  useEffect(() => {
    setState({ user, loading: true });
    return firebase.auth().onAuthStateChanged(user => {
      setState({ user, loading: false });
    });
  }, []);

  return { user, loading, logout };
};

export { useUser };
